'use client'

import { useTranslations } from 'next-intl'

import { useAirbridge } from '@/shared/config'
import { Button, Icon } from '@/shared/ui'

export const ReviewButton = () => {
  const t = useTranslations('main.review.button')
  const airbridge = useAirbridge()

  const handleButtonClick = () => {
    airbridge.openDeeplink({
      type: 'click',
      deeplinks: {
        ios: 'spacev33m2://app?type=sk&idx=0',
        android: 'spacev33m2://app?type=sk&idx=0',
        desktop: `${window.location.origin}/guest/room`,
      },
      ctaParams: {
        cta_param_1: 'main',
        cta_param_2: 'view_more_review',
        cta_param_3: '',
      },
    })
  }

  return (
    <Button
      variant="outline"
      color="secondary"
      size="large"
      fullWidth
      onClick={handleButtonClick}
    >
      {t('view_more')}
      <Icon name="arrow-right" size={16} strokeWidth={1} />
    </Button>
  )
}
